import { render, staticRenderFns } from "./Type13b.vue?vue&type=template&id=921b6452&"
import script from "./Type13b.vue?vue&type=script&lang=js&"
export * from "./Type13b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports